import React from "react";

const Radio = ({
  name,
  height,
  width,
  accentColor,
  onClick,
  onChange,
  checked,
  value,
}) => {
  return (
    <input
      type="radio"
      name={name}
      value={value}
      className="cursor-pointer"
      style={{
        height,
        width,
        verticalAlign: "middle",
        accentColor,
      }}
      checked={checked}
      onClick={onClick}
      onChange={onChange}
    />
  );
};

export default Radio;
